<script>
import WootSnackbar from './Snackbar.vue';
import { emitter } from 'shared/helpers/mitt';

export default {
  components: {
    WootSnackbar,
  },
  props: {
    duration: {
      type: Number,
      default: 2500,
    },
  },

  data() {
    return {
      snackMessages: [],
    };
  },

  mounted() {
    emitter.on('newToastMessage', this.onNewToastMessage);
    emitter.on('dismissToastMessage', this.onDismissToastMessage);
  },
  unmounted() {
    emitter.off('newToastMessage', this.onNewToastMessage);
    emitter.off('dismissToastMessage', this.onDismissToastMessage);
  },
  methods: {
    onNewToastMessage({ id, message, action, persistent = false }) {
      const key = id || new Date().getTime();
      this.snackMessages.push({
        key,
        message,
        action,
        persistent,
      });
      if (!persistent) {
        window.setTimeout(() => this.removeToastMessage(key), this.duration);
      }
    },
    onDismissToastMessage(id) {
      this.removeToastMessage(id);
    },
    removeToastMessage(key) {
      this.snackMessages = this.snackMessages.filter(
        message => message.key !== key
      );
    },
  },
};
</script>

<template>
  <transition-group
    name="toast-fade"
    tag="div"
    class="left-0 my-0 mx-auto max-w-[25rem] overflow-hidden absolute right-0 text-center top-4 z-[9999]"
  >
    <WootSnackbar
      v-for="snackMessage in snackMessages"
      :key="snackMessage.key"
      :message="snackMessage.message"
      :action="snackMessage.action"
      :is-persistent="snackMessage.persistent"
    />
  </transition-group>
</template>
